// @flow

//
// React
//
import React, { useState } from 'react';

//
// Material UI
//
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Image from 'mui-image';

//
// Props
//
type Props = {
    label: string,

    
    container: any,

    //
    // Data
    //
    value: any,
};

//
// Component
//
const ProductImageField = (props: Props) => {
    //
    // Hooks
    //
    const [open, setOpen] = useState(false);
    
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    // const code = (props.value) ? props.value.code : '';
    // const name = (props.value && props.value.name) ? props.value.name.bg : '';

    // PATCH: 
    // const sku = (props.stock) ? props.stock.sku : '';
    // TODO:
    // const imageUrl = `https://trix.tendenz.bg/rp/0153989_1.jpg`;
    const imageUrl = props.container.data.imageUrl;

    return (
        <>
            <Box style={{ padding: '8px', height: '100px' }}>
                {imageUrl ? (
                    <Image
                        src={imageUrl}
                        style={{ cursor: 'pointer', borderRadius: 8 }}
                        onClick={handleOpen}
                        // showLoading
                    />
                ) : null}
            </Box>

            <Modal open={open} onClose={handleClose}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        outline: 'none',
                        boxShadow: 24,
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        maxWidth: '90%',
                        maxHeight: '90%',
                        p: 1,
                    }}
                >
                <Image
                    src={imageUrl}
                    fit='contain'
                    style={{ maxWidth: '100%', maxHeight: '80vh' }}
                />
                </Box>
            </Modal>
        </>
    );
};
export default ProductImageField;
